<template>
  <!--
    Dashed border: an SVG stroked rect gives a dashed outline that follows rounded corners
    (CSS `border-dashed` can't round or size its dashes). No viewBox means percentages map to
    pixels 1:1, so dashes and radius stay crisp at any size. Place inside a `relative` parent;
    it fills it, ignores pointer events, and strokes in the parent's `currentColor`.
  -->
  <svg
    class="am3-dashed-border pointer-events-none absolute inset-0 h-full w-full"
    :style="{
      '--radius': `${radius}px`,
      '--thickness': `${thickness}px`,
      '--dash': `${dash}px`,
      '--gap': `${gap}px`,
    }"
    aria-hidden="true"
  >
    <rect class="am3-dashed-border-rect" />
  </svg>
</template>

<script setup lang="ts">
interface Props {
  // Corner radius in px - match the parent's rounded-* class (rounded-md = 6, rounded-lg = 8).
  radius?: number
  // Stroke weight in px.
  thickness?: number
  // Dash length and gap between dashes in px.
  dash?: number
  gap?: number
}

withDefaults(defineProps<Props>(), {
  radius: 4,
  thickness: 1,
  dash: 8,
  gap: 4,
})
</script>

<style scoped>
/* The 1px inset keeps the centered stroke fully inside the box, so a parent with
   overflow-hidden doesn't clip its outer edge. */
.am3-dashed-border-rect {
  x: 1px;
  y: 1px;
  width: calc(100% - 2px);
  height: calc(100% - 2px);
  rx: var(--radius);
  ry: var(--radius);
  fill: none;
  stroke: currentColor;
  stroke-width: var(--thickness);
  stroke-dasharray: var(--dash) var(--gap);
}
</style>
